// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductListPage_container__1SIaN","header":"ProductListPage_header__2NYOB"};